import { useEffect } from 'react'
import { metaMask, WalletTypes } from 'connectors'

export default function Web3Manager() {
  // Attempt to connect eagerly on mount
  useEffect(() => {
    if (!!window.localStorage.getItem('simple_user')) {
      const storedConnector = window.localStorage.getItem('connector')
      if (storedConnector === WalletTypes.MetaMask) {
        void metaMask.connectEagerly().catch(() => {
          console.debug('Failed to connect eagerly to metamask')
        })
      }
    }
  }, [])

  return null
}
